export interface IVoucherSimulationConfigOutput {
    year: number,
    assumedGrowth: number,
    mortalityRisk: number,
    eligibilityForTransplant: number,
    esrdRisk: number
}